import { f as fails$1 } from './fails.js';
import { i as isCallable$1 } from './is-callable.js';

var fails = fails$1;
var isCallable = isCallable$1;

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

export { isForced_1 as i };
//# sourceMappingURL=is-forced.js.map
